export const socialLoginScop = {
  google: 'openid profile email',
  apple: 'name email',
  facebook: 'openid email public_profile',
}

export const socialLoginFields = {
  facebook: 'id,first_name,last_name,email,picture',
}
